import * as MatchStatus from 'customer-data-filters-ui/filterQueryFormat/MatchStatus';
import { isLogicGroup } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { isPseudo as isPseudoFilterFamilyBasis } from '../converters/objectSeg/FilterObjectSegV2';
import memoize from 'transmute/memoize';
import { getDSAssetFamilyForType } from 'customer-data-filters-ui/converters/objectSeg/ObjectSegTypeToDSAssetFamily';
import { getDynamicFilterFamilyBasis } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import { INTEGRATION } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSFilterFamilies';
export const mapMatchStatus = status => {
  return status === 'ACCEPTED' ? MatchStatus.PASS : MatchStatus.FAIL;
};
const isPseudo = (baseFilterFamily, filterFamily) => {
  const assetFamilyOfCondition = getDSAssetFamilyForType(filterFamily) || filterFamily;
  const filterFamilyBasisOfCondition = getDynamicFilterFamilyBasis(assetFamilyOfCondition) || assetFamilyOfCondition;
  return isPseudoFilterFamilyBasis(baseFilterFamily, filterFamilyBasisOfCondition);
};
const getIndexes = memoize((conditions, baseFilterFamily) => {
  const filtersIndexes = [];
  const filterBranchesIndexes = [];
  Array.from(conditions.values()).forEach((condition, index) => {
    if (isLogicGroup(condition)) {
      if (isPseudo(baseFilterFamily, condition.filterFamily)) {
        for (let i = 0; i < condition.conditions.size; i++) {
          filtersIndexes.push(index);
        }
        return;
      }
      filterBranchesIndexes.push(index);
      return;
    }
    filtersIndexes.push(index);
  });
  return [filtersIndexes, filterBranchesIndexes];
});
const getBranchMatchStatusData = (condition, index, baseFilterFamily, filterBranchesIndexes, filtersIndexes, testFilterBranchesData, testFiltersData) => {
  const matchStatusData = {
    status: undefined,
    filtersData: undefined
  };
  if (isPseudo(baseFilterFamily, condition.filterFamily)) {
    // pseudo-group (multiple filters displayed as a group)
    if (testFiltersData) {
      const matchStatuses = testFiltersData.slice(filtersIndexes.indexOf(index), filtersIndexes.lastIndexOf(index) + 1);
      matchStatusData.filtersData = matchStatuses;
    }
  } else {
    matchStatusData.status = testFilterBranchesData && testFilterBranchesData[filterBranchesIndexes.indexOf(index)];
  }
  return matchStatusData;
};

// Integration filters are treated as one filter in ILS referenced using filterLines.
// In FQF they are treated as multiple conditions. The number of conditions ends up not
// matching the number of filters in ILS test results. This function repeats the filter
// test data for each integration line item.
const hydrateTestFiltersResultForIntegrations = (filterGroup, testFiltersResult) => {
  const conditionsArray = Array.from(filterGroup.conditions.entries());

  // iterate in reverse to since we are inserting elements
  for (let i = conditionsArray.length - 1; i >= 0; i--) {
    const condition = conditionsArray[i][1];
    if (getDynamicFilterFamilyBasis(condition.filterFamily) === INTEGRATION) {
      const numberOfConditions = condition.conditions.size;
      const testResults = Array.from({
        length: numberOfConditions
      }, () => Object.assign({}, testFiltersResult.filtersData[i], {
        status: undefined // since we only know if the group passes we cant show the indicator for individual conditions
      }));
      testFiltersResult.filtersData.splice(i, 1, ...testResults);
    }
  }
  return testFiltersResult;
};
export const processTestFiltersResponseNotMemoized = (baseFilterFamily, internalDraftValue, testFiltersResult) => {
  return Array.from(internalDraftValue.conditions.valueSeq()).map((filterGroup, groupIndex) => {
    const testDataForFilterGroup = hydrateTestFiltersResultForIntegrations(filterGroup, testFiltersResult && testFiltersResult[groupIndex]);
    const [filtersIndexes, filterBranchesIndexes] = getIndexes(filterGroup.conditions, baseFilterFamily);
    const filtersDataForGroup = Array.from(filterGroup.conditions).map(([, condition], conditionIndex) => {
      const testFiltersData = testDataForFilterGroup && testDataForFilterGroup.filtersData;
      const testFilterBranchesData = testDataForFilterGroup && testDataForFilterGroup.filterBranchesData;
      // child filter branches
      if (isLogicGroup(condition)) {
        const matchStatusData = getBranchMatchStatusData(condition, conditionIndex, baseFilterFamily, filterBranchesIndexes, filtersIndexes, testFilterBranchesData, testFiltersData);
        return matchStatusData;
      }
      // branch filters
      const indexInData = filtersIndexes.indexOf(conditionIndex);
      const testFilterData = testFiltersData && testFiltersData[indexInData];
      return testFilterData;
    }, []);
    return {
      status: testDataForFilterGroup === null || testDataForFilterGroup === void 0 ? void 0 : testDataForFilterGroup.status,
      filtersData: filtersDataForGroup
    };
  }, []);
};
export const processTestFiltersResponse = memoize(processTestFiltersResponseNotMemoized);